import { price } from '@/api/payment';

export default {
  namespaced: true,
  state: {
    loading: false,
    updateLoading: false,
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setUpdateLoading(state, isLoading) {
      state.updateLoading = isLoading;
    },
  },
  actions: {
    async create({ commit, dispatch }, { params, stripeAccount }) {
      try {
        commit('setLoading', true);
        const { data } = await price.create(params, stripeAccount);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
    async retrieve({ commit, dispatch }, { id, stripeAccount }) {
      try {
        commit('setLoading', true);
        const { data } = await price.retrieve(id, stripeAccount);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
    async update({ commit, dispatch }, { id, params, stripeAccount }) {
      try {
        commit('setUpdateLoading', true);
        const { data } = await price.update(id, params, stripeAccount);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setUpdateLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading,
    updateLoading: state => state.updateLoading,
  },
};
